<template>
  <div>
    <b-navbar
      toggleable="lg"
      type="dark"
      variant="info"
      class="navbar-extended"
    >
      <a href="/">
        <img class="header-img" src="@/assets/img/ciie.png" />
      </a>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav
          class="ml-auto d-flex align-items-center justify-content-end"
        >
          <b-nav-item class="mr-4" href="/carta-circular.pdf" target="_blank">
            <em class="far fa-file-alt color-primary-4 mr-2 font-16" />
            <span class="color-primary-4 font-14">
              {{ $t('LnkCircularLetter') }}
            </span>
          </b-nav-item>
          <b-nav-item class="mr-4"  @click="onOpenManualVideoHandler">
            <em class="far fa-video color-primary-4 mr-2 font-16" />
            <span class="color-primary-4 font-14">
              {{ $t('Video_Manual') }}
            </span>
          </b-nav-item>
          <b-nav-item
            class="mr-4"
            href="/manual-solicitante.pdf"
            target="_blank"
          >
            <em class="far fa-file-alt color-primary-4 mr-2 font-16" />
            <span class="color-primary-4 font-14">
              {{ $t('LnkManualSolicitante') }}
            </span>
          </b-nav-item>
          <b-nav-item class="mr-4" href="/memo-aclarativo.pdf" target="_blank">
            <em class="far fa-file-alt color-primary-4 mr-2 font-16" />
            <span class="color-primary-4 font-14">
              {{ $t('MemoAclarativo') }}
            </span>
          </b-nav-item>
          <div class="d-flex align-items-center">
            <span class="data-label">{{ $t('HeaderLanguageTitle') }}:</span>
            <custom-drop-action-item
              class="mr-4 pr-4 border-right"
              id="ddlLanguage"
              text="Idioma"
              v-model="selectedLanguage"
              :items="languageOptions"
              :set-selected-option="true"
              @click="onChangeLanguageHandler"
            />
          </div>
          <div class="mr-4">
            <!-- Only visible for Supervisors -->
            <Notifications />
          </div>

          <custom-drop-action-item
            is-icon-action
            class="mr-4"
            id="ddlUserProfile"
            text="Perfil"
            :items="userProfileOptions"
            @click="onSelectedUserProfileItem"
          >
            <img src="@/assets/img/user-icon.svg" />
          </custom-drop-action-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <ManualVideo
      ref="manualVideoRef"
      ></ManualVideo>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { name as appModuleName } from '@/store/modules/app';
import { name as userModuleName } from '@/store/modules/user';
import ManualVideo from '../../views/auth/ManualVideo.vue';

//components
import { CustomDropActionItem } from '@/components/common';

//mixins
import alertMixin from 'utils/mixins/alert.mixin';
import { userMixin } from '@/mixins/user.mixin';

//utils
import { i18n } from '@/i18n.js';

//constants
import languageOptionsEnum from '@/utils/constants/languageOptions.js';

import roles from '@/utils/constants/roles.js';
import Notifications from './components/Notifications.vue';
import { param } from 'jquery';

const CREATE_NEW_CASE_ROUTE_NAME = 'create-new-case';
const HOME_ROUTE_NAME = 'main';
const PROFILE_ROUTE_NAME = 'my-profile';
const SIGNIN_ROUTE_PATH = '/signin';
const EMAIL_ROUTE_PATH ='/email-dashboard';
export default {
  name: 'TheHeader',
  mixins: [alertMixin, userMixin],
  components: {
    CustomDropActionItem,
    Notifications,
    ManualVideo
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    excludeHelpCard: {
      type: Array,
      default: () => [], //array strings, para excluir items de caja de ayuda
    },
    contactInfo: {
      type: Object,
      default: () => ({
        phone: '787-773-6147',
        mail: 'apoyoconversion@de.pr.gov',
      }),
    },
    logo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isUserPasswordChangeVisible: false,
      selectedLanguage: null,
      accessOptions: [
        {
          label: i18n.t('VirtualLibrary'),
          icon: 'atlas',
          isButtonType: true,
          visible: true,
        },
        {
          label: i18n.t('LnkCircularLetter'),
          icon: 'file-alt',
          isButtonType: true,
          visible: true,
        },
        {
          label: i18n.t('MemoAclarativo'),
          icon: 'file-alt',
          isButtonType: true,
          visible: true,
        },
        {
          label: i18n.t('LnkManualSolicitante'),
          icon: 'file-alt',
          isButtonType: true,
          visible: true,
        },
        {
          label: i18n.t('SurveyRating'),
          icon: 'chart-bar',
          isButtonType: true,
          visible: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
      isNavOpened: 'getIsNavOpen',
    }),
    ...mapState(appModuleName, ['isCaseListOpen']),
    displayChangeUserPassword() {
      return this.isUserPasswordChangeVisible;
    },
    languageOptions() {
      return languageOptionsEnum;
    },
    
    userProfileOptions() {
      let options = [
        {
          id: 1,
          label: this.roleName(),
          icon: 'user font-20 mr-2',
          isButtonType: false,
          visible: true,
        },
        {
          id: 2,
          label: i18n.t('MyProfile'),
          icon: 'user font-20 mr-2',
          isButtonType: true,
          visible: true,
        },
        {
          id: 6,
          label: 'Solicitudes con más de 6 meses',
          icon: 'envelope',
          isButtonType: true,
          visible: this.isSupervisor(),
        },
        {
          id: 3,
          label: i18n.t('adminuser.text'),
          icon: 'users font-20 mr-2',
          isButtonType: true,
          visible: this.isAdmin() || this.isSupervisor(),
        },
        {
          id: 4,
          label: i18n.t('Logout'),
          icon: 'power-off font-20 mr-2',
          isButtonType: true,
          visible: true,
        },
      ];

      //Only return options when visible is true
      return options.filter((o) => o.visible === true);
    },
  },
  mounted() {
    this.loadSelectedLanguage();
    console.log(this.userId);
  },
  methods: {
    ...mapMutations(appModuleName, ['setOpenCaseList']),
    ...mapActions(userModuleName, ['logout']),
    ...mapGetters(userModuleName, {
      roleName: 'role',
    }),
    isSupervisor() {
      return this.roleName()?.toLowerCase() === roles.SUPERVISOR.toLowerCase();
    },
    onOpenManualVideoHandler() {
      this.$refs.manualVideoRef?.showModal();
    },
    isApplicant() {
      return this.roleName()?.toLowerCase() === roles.APPLICANT.toLowerCase();
    },
    isAdmin() {
      return this.roleName()?.toLowerCase() === roles.ADMIN.toLowerCase();
    },
    isSupervisor() {
      return this.roleName()?.toLowerCase() === roles.SUPERVISOR.toLowerCase();
    },
    isInvestigator() {
      return this.roleName()?.toLowerCase() === roles.Investigator.toLowerCase();
    },
    ShowHidePasswordChange() {
      this.isUserPasswordChangeVisible = true;
    },
    onClosing() {
      this.isUserPasswordChangeVisible = false;
    },
    async createNewCaseHandler() {
      if (this.$route.name !== CREATE_NEW_CASE_ROUTE_NAME) {
        if (this.itemModel?.businessId) {
          const answer = await this.ShowCancelModal(
            'Crear Nuevo Caso',
            '¿Está seguro que desea crear un nuevo caso?',
            'Si',
            'No'
          );
          if (answer) {
            this.disposeCaseInfo();
            this.$router.push({
              name: CREATE_NEW_CASE_ROUTE_NAME,
            });
          }
        } else {
          this.disposeCaseInfo();
          this.$router.push({
            name: CREATE_NEW_CASE_ROUTE_NAME,
          });
        }
      } else {
        this.disposeCaseInfo();
      }
    },
    goToHomeHandler() {
      this.disposeCaseInfo();
      if (this.isMobile) {
        this.setOpenCaseList(false);
      }
      if (this.$route.name !== HOME_ROUTE_NAME) {
        this.setIsNavOpen({
          isNavOpen: false,
          navOption: {},
        });
        this.$router.replace({
          name: HOME_ROUTE_NAME,
        });
      }
    },
    openCaseListHandler() {
      this.setOpenCaseList(!this.isCaseListOpen);
    },
    async onSelectedUserProfileItem(value) {
      // My profile
      if (value?.id === 2) {
        this.$router.push(
        `${PROFILE_ROUTE_NAME}/${this.userId}`
       );
      }

      if (value?.id === 4) {
        // Logout
        await this.logout();
        window.location.replace(SIGNIN_ROUTE_PATH);
      }

      if (value?.id === 6) {
        // Logout
        this.$router.push(EMAIL_ROUTE_PATH);
      }
      if (value?.id === 3) {
        // Administrate Users
        this.$router.push({
          name: 'administrate-users',
        });
      }
    },
    onChangeLanguageHandler(value) {
      if (value?.id) {
        this.$i18n.locale = value.id;
        window.location.reload();
      }
    },
    loadSelectedLanguage() {
      this.selectedLanguage = this.languageOptions.find(
        (x) => x.id === this.userSelectedLang
      );

      // this.accessOptions = this.accessOptions.filter((o) =>
      //    o.visible === true
      // );
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';

.navbar-extended {
  height: 89px;
  background: #fff !important;
  &--is-normal {
    right: 0px !important;
  }
}

.header-img {
  height: 69px;
  margin-top: 3px;
}

@media only screen and (max-width: 768px) {
  .header-img {
    height: 45px;
  }
}
</style>
